import classNames from 'classnames';
import { forwardRef } from 'react';
const sectionContainerCss = "sksoldl";
export const SectionContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionContainerCss, props.className)} />;
});

require("./section_container.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./section_container.js");